module.exports = "<atn-list-box\r\n  #list\r\n  name=\"Series\"\r\n  outputField=\"name\"\r\n  [service]=\"dataService\"\r\n></atn-list-box>\r\n\r\n<serie-form\r\n  *ngIf=\"list.showForm\"\r\n  [id]=\"list.selectedItemId\"\r\n  (onSave)=\"list.hideFormAndReload()\"\r\n  (onDuplicate)=\"list.hideFormAndReload()\"\r\n  (onRemove)=\"list.hideFormAndReload()\"\r\n  (onBack)=\"list.hideForm()\"\r\n></serie-form>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/series/serie-list/serie-list.component.html
// module id = ./libs/atenea-cms-brand/src/series/serie-list/serie-list.component.html
// module chunks = main